export class WireErrors {
    // draft status errors
    hasNoName: boolean = false;
    nameExists: boolean = false;

    // submitted status errors
    hasNoHeadline: boolean = false;
    headlineExceedsByteLengthLimit: boolean = false;
    hasNoCompanyName: boolean = false;
    hasNoDateline: boolean = false;
    hasNoContactName: boolean = false;
    hasNoContactEmail: boolean = false;
    wrongEmailFormat: boolean = false;
    insufficientQuota: boolean = false;
    hasCompanyLogoError: boolean = false;
    hasCompanyBioError: boolean = false;
    hasCompanyAddressError: boolean = false;
    hasNoTextBlockError: boolean = false;
    hasNoTextContentError: boolean = false;
    hasNoImageOrVideoContentError: boolean = false;
    hasNoSocialLinkContentError: boolean = false;
    hasContactBlockContentError: boolean = false;
    hasScheduleDateError: boolean = false;
    hasImageInTextBlock: boolean = false;
    hasSocialLinkError: boolean = false;
    invalidImageContentError: boolean = false;
    hasImageTotalSizeError: boolean = false;

    errorCount: number = 0;
}

export const wireDefaultTabErrors = [
    'hasNoContactName',
    'hasNoContactEmail',
    'wrongEmailFormat',
    'insufficientQuota',
    'hasScheduleDateError'
];
